import { List as ImmutableList, fromJS as ConvertToImmutable } from 'immutable';

import { ZAP_DECK_FETCH_SUCCESS, ZAP_DECK_UPDATE_SUCCESS } from '../actions/zap_deck';

const initialState = ImmutableList([]);

export default function zap_deck(state = initialState, action) {
  if (action.type === ZAP_DECK_FETCH_SUCCESS || action.type === ZAP_DECK_UPDATE_SUCCESS) {
    state = ConvertToImmutable(action.amounts);
  }

  return state;
}
